import { useState, useEffect } from 'react';
import { css, etiColors, keyframes } from '@eti/styles';
import PropTypes from 'prop-types';

const loadingAnimationStart = keyframes`
  0% { width: 0; }
  10% { width: 10%; }
  20% { width: 20%; }
  30% { width: 30%; }
  40% { width: 40%; }
  50% { width: 50%; }
  60% { width: 60%; }
  70% { width: 70%; }
`;

const loadingAnimationFinish = keyframes`
  70% { width: 70%; }
  85% { width: 85%; }
  99% { width: 100%; }
  100% { width: 0; }
`;

const animation = (shouldShowResultsLoader) =>
  `animation: ${
    shouldShowResultsLoader ? `${loadingAnimationStart} 0.7s;` : `${loadingAnimationFinish} 0.3s;`
  }
   animation-fill-mode: forwards;`;

const searchResultsLoaderWrapperStyles = (shouldShowResultsLoader, showAnimation) => css`
  background-color: ${etiColors.info.solid};
  height: ${showAnimation ? '3px' : '0'};
  ${showAnimation ? animation(shouldShowResultsLoader) : 'width: 0;'}
`;

const SearchResultsLoader = ({ shouldShowResultsLoader }) => {
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (!showAnimation && shouldShowResultsLoader) {
      setShowAnimation(true);
    }
    if (showAnimation && !shouldShowResultsLoader) {
      setShowAnimation(false);
    }
  }, [showAnimation, shouldShowResultsLoader]);

  return (
    <div
      className={searchResultsLoaderWrapperStyles(shouldShowResultsLoader, showAnimation)}
      data-testid="resultPage-searchResults-loader"
    />
  );
};

SearchResultsLoader.propTypes = {
  shouldShowResultsLoader: PropTypes.bool,
};

export default SearchResultsLoader;
